import ValueDisplay from 'src/components/ValueDisplay';
import { UIOrderType } from '@velocity-exchange/common';
import { BigNum } from '@velocity-exchange/sdk';
import { PRICE_FALLBACK_DISPLAY_VALUE } from 'src/components/TradeForm/consts';

interface Props {
	orderType: UIOrderType;
	liqPriceBefore: number;
	liqPriceBeforeString: string;
	liqPriceAfter: number;
	liqPriceAfterString: string;
	userAccountIsReady: boolean;
	selectedMarketIndex: number | undefined;
	baseSize: BigNum;
	isMobileScreenSize: boolean;
}

export default function LiquidationPriceDisplay({
	orderType,
	liqPriceBefore,
	liqPriceBeforeString,
	liqPriceAfter,
	liqPriceAfterString,
	userAccountIsReady,
	selectedMarketIndex,
	baseSize,
	isMobileScreenSize,
}: Props) {
	if (
		![
			'limit',
			'market',
			'oracle',
			'stopMarket',
			'stopLimit',
			'oracleLimit',
		].includes(orderType)
	) {
		return null;
	}

	const liqPriceAfterStringOrFallback = (() => {
		if (!liqPriceAfterString || liqPriceAfter === 0) {
			return PRICE_FALLBACK_DISPLAY_VALUE;
		}

		return `~${liqPriceAfterString}`;
	})();

	if (isMobileScreenSize) {
		return (
			<ValueDisplay.Default
				label="Liq. Price"
				labelClassName="shrink"
				value={liqPriceAfterStringOrFallback}
			/>
		);
	}

	return (
		<ValueDisplay.ValueChange
			label="Liq. Price"
			previousValue={liqPriceBefore}
			afterValue={liqPriceAfter}
			previousValuePrint={liqPriceBeforeString}
			afterValuePrint={liqPriceAfterStringOrFallback}
			forceWhite
			nullOverride={
				!userAccountIsReady ||
				selectedMarketIndex === undefined ||
				isNaN(selectedMarketIndex) ||
				(!liqPriceBefore && !liqPriceAfter)
			}
			customOverride={PRICE_FALLBACK_DISPLAY_VALUE}
			overrideNoValueChange={!baseSize || baseSize.eqZero()}
		/>
	);
}
